var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-circle',{attrs:{"config":{
                                x: _vm.res.x,
                                y: _vm.res.y,
                                radius: 20,
                                fill: 'black',
                                stroke: 'black',
                                strokeWidth: 5,
                                visible:_vm.show,
                                listening:false,
                                }}}),_c('v-text',{attrs:{"config":{
                                 x: _vm.res.x-25,
                                y: _vm.res.y+30,
                          width:50,
                          fill: 'black',
                          text: _vm.theCaracValue,
                          fontSize:18,
                          fontStyle:'bold',
                          align:'center',
                          visible:_vm.show,
                          listening:false,
                          }}}),(_vm.nothingIsMoving)?_c('v-image',{attrs:{"config":{
                                  x : _vm.res.x-8,
                                  y: _vm.res.y-36,
                                  image:_vm.imgClose,
                                  }},on:{"click":_vm.confirmDelete}}):_vm._e(),_c('v-circle',{ref:"resultat",attrs:{"name":"resultat","config":{
                                x: _vm.res.x,
                                y: _vm.res.y,
                                srcX : _vm.res.x,
                                srcY: _vm.res.y,
                                groupRef: _vm.res.from,
                                radius: 15,
                                fill: _vm.res.data.color,
                                stroke: '#606266',
                                strokeWidth: _vm.selectionned,
                                draggable: _vm.imAlive,
                                type:_vm.res.type,
                                }},on:{"dragstart":_vm.linkSortieDragStart,"dragmove":_vm.linkSortieDragMove,"dragend":_vm.linkSortieDragStop,"mouseenter":_vm.cursorMove,"mouseleave":_vm.cursorDefault,"click":_vm.editResultat}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }